import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialSellerOrderFilterData,
  InitialSellerOrderFilterDataVariables
} from "./types/InitialSellerOrderFilterData";
import {
  SellerOrdersDownload,
  SellerOrdersDownloadVariables
} from "./types/SellerOrdersDownload";
import {
  SellerOrdersReport,
  SellerOrdersReportVariables
} from "./types/SellerOrdersReport";

export const sellerOrdersReportList = gql`
  ${pageInfoFragment}
  query SellerOrdersReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: SellerOrdersFilterInput!
  ) {
    sellerOrders(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          vertical
          order_status
          store_order_status
          order_date
          completed_at
          store_completed_at
          order_code
          store_order_code
          shipping_method_name
          shipping_schedule
          payment_method_type
          voucher_code
          retail_price
          sales_discount_total
          selling_price
          delivery_fee
          price_paid
          order_cancel_reason
          store_order_cancel_reason
          voucher_discount_total
        }
      }
    }
  }
`;

export const useSellerOrdersQuery = makeBossQuery<
  SellerOrdersReport,
  SellerOrdersReportVariables
>(sellerOrdersReportList);

export const sellerOrdersDownload = gql`
  ${pageInfoFragment}
  query SellerOrdersDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: SellerOrdersFilterInput!
  ) {
    sellerOrders(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          mall_name
          brand_name
          vertical
          order_status
          store_order_status
          order_date
          shipping_schedule
          completed_at
          store_completed_at
          order_code
          store_order_code
          shipping_method_name
          payment_method_type
          voucher_code
          retail_price
          sales_discount_total
          selling_price
          delivery_fee
          voucher_discount_total
          price_paid
          order_cancel_reason
          store_order_cancel_reason
        }
      }
    }
  }
`;

export const useSellerOrdersDownload = makeBossQuery<
  SellerOrdersDownload,
  SellerOrdersDownloadVariables
>(sellerOrdersDownload);

export const initialSellerOrderDataQuery = gql`
  query InitialSellerOrderFilterData($mall: [ID]) {
    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialSellerOrderFilterDataQuery = makeQuery<
  InitialSellerOrderFilterData,
  InitialSellerOrderFilterDataVariables
>(initialSellerOrderDataQuery);
